import React from 'react';

import WsIconProps from './IconProps';

const WsNoTimeLineData: React.FC<WsIconProps> = ({ width = 113, height = 98 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="13.5" y="0.5" width="87" height="29" rx="3.5" fill="white" stroke="#ADE8F4" />
    <rect x="21" y="17" width="54" height="3" fill="#CAF0F8" />
    <rect x="21" y="22" width="15" height="3" fill="#CAF0F8" />
    <rect x="13.5" y="68.5" width="87" height="29" rx="3.5" fill="white" stroke="#ADE8F4" />
    <rect x="21" y="85" width="54" height="3" fill="#CAF0F8" />
    <rect x="21" y="90" width="15" height="3" fill="#CAF0F8" />
    <rect x="13.5" y="34.5" width="99" height="29" rx="3.5" fill="#CAF0F8" stroke="#48CAE4" />
    <rect x="23" y="51" width="61" height="3" fill="#ADE8F4" />
    <rect x="23" y="56" width="17" height="3" fill="#ADE8F4" />
    <rect x="21" y="5" width="27" height="9" rx="3" fill="#00B4D8" />
    <rect x="21" y="73" width="27" height="9" rx="3" fill="#00B4D8" />
    <rect x="23" y="39" width="27" height="9" rx="3" fill="#00B4D8" />
    <line x1="3.5" y1="82" x2="3.5" y2="15" stroke="#90E0EF" />
    <circle cx="3.5" cy="15.5" r="3.5" fill="#00B4D8" />
    <circle cx="3.5" cy="49.5" r="3.5" fill="#00B4D8" />
    <circle cx="3.5" cy="81.5" r="3.5" fill="#00B4D8" />
  </svg>
);

export default WsNoTimeLineData;
